import { Flex, Text } from '@chakra-ui/react';
import { t } from 'i18next';
import React, { useMemo } from 'react';
import { Color } from '../../theme/color';

export enum Filter {
	ALL,
	USER,
	GAME,
	TRANSACTION,
}

export const SearchSummary = ({
	selectedType,
	setSelectedType,
	count: { all, user, game, transaction },
}: {
	selectedType: Filter;
	setSelectedType: React.Dispatch<React.SetStateAction<Filter>>;
	count: { all: number; user: number; game: number; transaction: number };
}) => {
	const items = useMemo(
		() => [
			{ type: Filter.ALL, name: t('search.all'), count: all },
			{ type: Filter.USER, name: t('search.users'), count: user },
			{ type: Filter.GAME, name: t('search.games'), count: game },
			{ type: Filter.TRANSACTION, name: t('search.transactions'), count: transaction },
		],
		[t, all, user, game, transaction]
	);

	return (
		<Flex
			overflowX="auto"
			css={{
				'::-webkit-scrollbar': {
					width: 0,
					background: 'transparent',
				},
			}}
		>
			<Flex
				width="412px"
				pb="4px"
			>
				{items.map(item => (
					<Flex
						color="white"
						key={item.type.toString()}
						boxShadow={item.type === selectedType ? `0 4px 0 0px ${Color.ACTION}` : 'unset'}
						flex="1 1 0px"
						gridGap="8px"
						fontSize="14px"
						lineHeight="18px"
						alignItems="center"
						justifyContent="center"
						padding="12px 16px"
						cursor="pointer"
						onClick={() => setSelectedType(item.type)}
					>
						<Text
							textOverflow="ellipsis"
							whiteSpace="nowrap"
							overflow="hidden"
						>
							{item.name}
						</Text>
						<Flex
							padding="6px 12px"
							background="#3F4554"
							borderRadius="4px"
							fontSize="12px"
							lineHeight="15px"
							fontWeight="700"
						>
							{item.count}
						</Flex>
					</Flex>
				))}
			</Flex>
		</Flex>
	);
};
